import React from 'react';

const WorkProcessEight = () => {
  return (
    <>
      {/* work-process-area start */}
      <div id="como-funciona" className="work-process-area work-process-area_8 pd-top-100">
        <div className="container">
          <div className="section-title text-center">
            <h6 className="sub-title">PROCESO SIMPLE</h6>
            <h2 className="title">
              Cómo <span>funciona</span> FirmasCheck
            </h2>
          </div>
          <div className="row justify-content-center">
            <div className="col-xl-2 col-md-4 col-sm-6 mb-4">
              <div className="single-work-process-inner text-center">
                <div className="thumb mb-3">
                  <img src="assets/img/icon/9.svg" alt="img" />
                </div>
                <div className="details">
                  <p className="process-count">Paso 01</p>
                  <h5 className="mb-3">Sube tu documento</h5>
                  <p className="content">
                    Arrastra tu PDF y agrega a los firmantes con nombre, email y RUT.
                  </p>
                </div>
              </div>
            </div>
            <div className="col-xl-2 col-md-4 col-sm-6 mb-4">
              <div className="single-work-process-inner text-center">
                <div className="thumb mb-3">
                  <img src="assets/img/icon/10.svg" alt="img" />
                </div>
                <div className="details">
                  <p className="process-count">Paso 02</p>
                  <h5 className="mb-3">Define dónde firman</h5>
                  <p className="content">
                    Ubica firmas, iniciales o campos de texto en el documento.
                  </p>
                </div>
              </div>
            </div>
            <div className="col-xl-2 col-md-4 col-sm-6 mb-4">
              <div className="single-work-process-inner text-center">
                <div className="thumb mb-3">
                  <img src="assets/img/icon/11.svg" alt="img" />
                </div>
                <div className="details">
                  <p className="process-count">Paso 03</p>
                  <h5 className="mb-3">Validación de identidad</h5>
                  <p className="content">
                    Cada firmante recibe un enlace y un código OTP por correo (vigencia: 5 minutos).
                  </p>
                </div>
              </div>
            </div>
            <div className="col-xl-2 col-md-4 col-sm-6 mb-4">
              <div className="single-work-process-inner text-center">
                <div className="thumb mb-3">
                  <img src="assets/img/icon/12.svg" alt="img" />
                </div>
                <div className="details">
                  <p className="process-count">Paso 04</p>
                  <h5 className="mb-3">Firma y seguimiento</h5>
                  <p className="content">
                    El firmante ingresa el OTP, firma y ¡listo! Te avisamos cada vez que alguien firma.
                  </p>
                </div>
              </div>
            </div>
            <div className="col-xl-2 col-md-4 col-sm-6 mb-4">
              <div className="single-work-process-inner text-center">
                <div className="thumb mb-3">
                  <img src="assets/img/icon/13.svg" alt="img" />
                </div>
                <div className="details">
                  <p className="process-count">Paso 05</p>
                  <h5 className="mb-3">Documento final</h5>
                  <p className="content">
                    Al completarse, todos reciben el PDF firmado con QR de verificación, más IP y timestamp.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* work-process-area end */}
    </>
  );
};

export default WorkProcessEight;
